import { Pipe, PipeTransform } from '@angular/core';
import { INVOICE_STATUS_LABEL, InvoiceStatus } from '~gc/domains/invoices';

@Pipe({ name: 'invoiceStatusLabel' })
export class InvoiceStatusLabelPipe implements PipeTransform {
  transform(status: string, reportsProgress: boolean = false): string {
    return status === InvoiceStatus.Paid && reportsProgress ? 'Approved' : INVOICE_STATUS_LABEL[status];
  }
}
